import { CharacterGender } from "@1games-ru/region-shared/dist/enums/character/character";
import { DocumentData } from "@1games-ru/region-shared/dist/types/documents/documentData";
import clsx from "clsx";

export default function MedicalCard({ docNumber, owner, expiresAt }: DocumentData) {
  return (
    <div
      className={clsx(
        "w-[30rem] h-[18.5rem] bg-[#EDFBFB] rounded-[1.25rem] p-[1.875rem]",
        "flex items-end justify-between",
        "text-dark-800 font-medium",
      )}
      style={{
        backgroundImage: "url(./svg/documents/medical-id.webp)",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      <div className="w-[17.625rem] h-full flex flex-col items-center">
        <div className="w-[10.5rem]">
          <div className="text-14 text-[#233D57] uppercase">МЕДИЦИНСКАЯ КАРТА</div>
          <div className="text-13 uppercase">г. Санкт-Петербург</div>
        </div>
        <div className="w-full flex items-stretch gap-5 mt-[2rem]">
          <img
            src={owner.photo}
            alt=""
            className="w-[6.25rem] h-[7.5rem] pointer-events-none border border-dark-800 bg-white"
          />
          <div className="flex flex-col items-start gap-3.5">
            <div>
              <div className="text-14 uppercase">{owner.firstName}</div>
              <div className="text-15 text-[#233D57] mt-0.5">Имя</div>
            </div>
            <div>
              <div className="text-14 uppercase">{owner.lastName}</div>
              <div className="text-15 text-[#233D57] mt-0.5">Фамилия</div>
            </div>
          </div>
        </div>
        <div className="w-full flex items-end gap-5 mt-auto">
          <div className="w-[6.25rem] shrink-0">{docNumber}</div>
          <div className="relative text-15 text-[#233D57] border-t border-[#233D57] pt-1">
            {owner?.signature && (
              <div
                className="absolute z-1 h-[4rem] -translate-y-[3.5rem] w-fit pointer-events-none"
                style={{
                  backgroundImage: `url(${owner.signature})`,
                  backgroundSize: "contain",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                }}
              />
            )}
            Личная подпись
          </div>
        </div>
      </div>
      <div className="flex flex-col items-end gap-4 text-right">
        <div>
          <div className="text-14">{owner.sex === CharacterGender.Female ? "Ж" : "М"}</div>
          <div className="text-15 text-[#233D57]">Пол</div>
        </div>
        <div>
          <div className="text-14 flex items-center gap-1">
            {["А", "Б", "В", "Г"].map((item) => (
              <div
                key={item}
                className={clsx(
                  "flex items-center justify-center w-[1.25rem] aspect-square text-13 leading-3 font-bold shrink-0 border-2 border-dark-800",
                  { "opacity-50": item !== "A" },
                )}
              >
                {item}
              </div>
            ))}
          </div>
          <div className="text-15 text-[#233D57]">Категория</div>
        </div>
        <div>
          <div className="text-14">{expiresAt || "-"}</div>
          <div className="text-15 text-[#233D57]">Срок действия</div>
        </div>
        <div>
          <div className="text-14">{owner.dateOfBirth}</div>
          <div className="text-15 text-[#233D57]">Дата рождения</div>
        </div>
      </div>
    </div>
  );
}
